import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationHttpClient } from '@app/core/http';

@Injectable({ providedIn: 'root' })
export class WardsService {

  constructor(private http: ApplicationHttpClient) {
  }

  public getWards(districtCode: string) {
    return this.http.get(`/api/app/ward/district?districtCode=${ districtCode }`, {
    });
  }

  public getWardsByCityCode(cityCode: string) {
    return this.http.get(`/api/app/ward/city?cityCode=${ cityCode }`, {
    });
  }

  public getDetailById(id: string) {
    return this.http.get('/api/app/ward', {
      params: { id }
    });
  }

}
